// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-33c40d66] .el-dialog__body {\n  padding-bottom: 0;\n}\n.form[data-v-33c40d66] {\n  padding-right: 20px;\n}", ""]);
// Exports
module.exports = exports;
